import React from 'react';
import './ModelBox.scss';
import { AdminMonitorStatsResponse } from '../../../../shared/models/admin/dashboard/AdminMonitorStatsResponse';

interface ModelBoxProps {
  activeMonitors: number | null;
  stats: AdminMonitorStatsResponse | null;
  header: string;
  isToday: boolean;
}

const ModelBox: React.FC<ModelBoxProps> = ({ stats, header, isToday }) => {
  if (!stats) {
    return <></>;
  }

  return (
    <div className="dashboard__table">
      <div className="dashboard-table__row dashboard-table__row--header">{header}</div>
      <div className="dashboard-table__row">
        <div>All questions:</div>
        <div>{stats.totalMonitors}</div>
      </div>
      <div className="dashboard-table__row">
        <div>{isToday ? 'Done:' : 'Collected:'}</div>
        <div>{stats.alreadyCollected}</div>
      </div>
      <div className="dashboard-table__row">
        <div>{isToday ? 'To do:' : 'Not collected:'}</div>
        <div>{stats.remainingToCollect}</div>
      </div>
    </div>
  );
};

export default ModelBox;
